<template>
  <div class="ksm-modus__ansicht-wrapper">
    <split-layout :cols="2" :sidebar_right_width="'width:20% '">
      <!-- split-layout main -->
      <div slot="main-content" class="ksm-texte__modus-main">
        <!-- toolbar -->
        <slot name="modusindex-toolbar"></slot>

        <div class="ksm-modus__ansicht-main-wrapper">
          <!-- ansicht main content -->
          <div class="ksm-modus__ansicht-main">
            <!-- einführung -->
            <div v-if="seiteIdx<1" class="ksm-ansicht__einfuehrung">
              <div class="__title">Einführung</div>
              <div
                class="__body ksm-content-font ksm-hyphens"
                lang="de"
                :class="modusId"
                style="overflow:auto"
                v-html="einfuehrung"
              ></div>
            </div>
            <!-- deepzoom -->
            <div class="ksm-ansicht-content">
              <deepzoom-view
                @changePage="changeSeite"
                :modusOption="modusOption"
                :seiteIdx="seiteIdx"
                :seiten="seiten"
                key="deep_ansicht_1"
              ></deepzoom-view>
            </div>
          </div>
          <!-- ansicht main content end -->
        </div>

        <!-- thumbnail start -->
        <div class="ksm-ansicht-footer">
          <foot-thumbnail
            @selectItem="changeSeite"
            :seiten="seiten"
            :seiteIdx="seiteIdx"
            :aligen="'horizontal'"
          ></foot-thumbnail>
        </div>
        <!-- thumbnail end -->
      </div>
      <!-- split-layout main end -->
      <!-- spit-layout sidebar -->
      <div slot="sidebar-2" class="ksm-flex-1" style="position:relative">
        <sidebar-view :merz="merz" :modusOption="modusOption" :seiteIdx="seiteIdx"></sidebar-view>
      </div>
    </split-layout>
  </div>
</template>

<script>
import DeepzoomView from "comps/DeepzoomView.vue";
import Thumbnail from "comps/Thumbnail.vue";
import SplitLayout from "comps/SplitLayout.vue";
import Sidebar from "./Sidebar.vue";
import { mapGetters, mapState } from "vuex";
import MixinsModus from "comps/mixins/Modus.vue";

export default {
  props: ["viewKey"],
  mixins: [MixinsModus],
  components: {
    "deepzoom-view": DeepzoomView,
    "split-layout": SplitLayout,
    "sidebar-view": Sidebar,
    "foot-thumbnail": Thumbnail
  },
  data() {
    return {
      modusId: "ansichtsmodus"
    };
  },
  methods: {},
  computed: {
    einfuehrung() {
      let merz = this.merz;
      if (!merz || !merz.$_einfuehrungDoc) {
        return;
      }

      let newDiv = this.$_getNewHtmlElement(
        merz.$_einfuehrungDoc._source["114_html"],
        merz,
        merz.$_einfuehrungDoc,
        true
      );

      return newDiv.outerHTML;
    }
  }
};
</script>

<style lang="scss"
 scoped>
$footerHeight: 150px;

.ksm-modus__ansicht-wrapper {
  @extend .ksm-flex;
  @extend .ksm-content-font;
  justify-content: center;
}
.ksm-modus__ansicht-main-wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-texte__modus-body;
  position: relative;
}
.ksm-modus__ansicht-main {
  position: absolute;
  width: 100%;
  height: 100%;
  @extend .ksm-flex;

  .ksm-ansicht__einfuehrung {
    @extend .ksm-flex-1;
    @extend .ksm-flex-column;
    max-width: 500px;
    margin-right: 20px;
    .__title {
      @extend .ksm-control-font;
      background-color: $lightGrey;
      border: 2px solid $darkGrey;
      height: 27px;
      font-size: 11pt;
      color: #000;
      padding-left: 10px;
    }
    .__body {
      @extend .ksm-flex-1;
      overflow: auto;
      display: block;
      position: relative;
      border: 2px solid $darkGrey;
      border-top-width: 0;
      padding: 10px;
    }
  }
  .ksm-ansicht-content {
    @extend .ksm-flex-1;
  }
}

.ksm-ansicht-footer {
  @extend .ksm-flex-00auto;
  height: $footerHeight;
  @extend .ksm-flex;
  margin: 0px 20px;
}
</style>


// WEBPACK FOOTER //
// Ansicht.vue?b006c94c